export class AddressHelper {
  constructor(profile) {
    this.profile = profile
    this.addresses = this.profile.addresses
    // UseMe:: use the below if api not returning main address on top of  the list.
    // arrangeArray(this.profile.addresses, e => e.default === 'y')
  }

  getFilteredAddresses() {
    const addresses = this.addresses || []
    const filteredAddress = addresses.filter(address => address.line1 !== 'DUMMY'
        && address.city !== 'DUMMY'
        && address.type !== '_CnC')
    return filteredAddress || []
  }

  getFormattedAddressList() {
    const address = this.addresses || []
    const formattedAddressList = address.map((address) => {
      let { line1, postcode } = address
      const { line2, city } = address
      line1 = line1.replace(',', '')
      postcode = postcode.replace(/\s/g, '')
      return line2
        ? `${line1}, ${line2}, ${city}, ${postcode}`
        : `${line1}, ${city}, ${postcode}`
    })
    return formattedAddressList || []
  }
}

export const getMainAddressString = (addresses = []) => {
  const mainAddress = addresses.filter(address => address.default === 'y'
      && address.line1 !== 'DUMMY'
      && address.city !== 'DUMMY')
  if (mainAddress[0]) {
    const { line2, addressId, city } = mainAddress[0] || {}
    let { line1, postcode } = mainAddress[0] || {}
    line1 = line1.replace(',', '')
    postcode = postcode.replace(/\s/g, '')
    const mainAddressString = line2
      ? `${line1}, ${line2}, ${city}, ${postcode}`
      : `${line1}, ${city}, ${postcode}`
    return [mainAddressString || '', addressId]
  }
  return ''
}
